
import moment from "moment";

import { get29DaysAgoFromDate_YYYYMMDD, dateToYYYYMMDD } from "../utils/date";
import { getCurrentUser } from ".";

import { enums } from "../enums/"
import { ACTION_TYPE } from "./ActionTypes";

import { postJsonRequest, makeCompleteUrlFromLastPart} from "../utils/requestHelper";
import { getConsumingAssets, getConsumingAssetsByCountry } from "./AssetsConsumingActions";
import { DEFAULT_CERTIFICATE_STATUS_FILTER_ARRAY } from "../constants/Miscellaneous";
import { UserRole } from "../enums/UserRole";
import { userHasRole, getUserMatchingFrequency } from "./UsersActions";
import { checkVariableIsDefinedOrThrow } from "../utils/validation";

export const getCountriesRelatedToUserConsumingSites = () => async dispatch => {
  let consumingSites = await getConsumingAssets();
  let uniqueCountriesArray = [...new Map(consumingSites.map(consumingSite => [consumingSite.countryLink._id.toString(), consumingSite.countryLink])).values()];
  if(uniqueCountriesArray.length > 1) {
    dispatch({
      type: ACTION_TYPE.DASHBOARD.ENABLE_COUNTRY_NAVIGATION,
      payload: uniqueCountriesArray
    });
  }
}

export const getUserFrontEndData_CO2_Energy_AverageDistance = async (startDate, endDate, statusFilterArray) => {
  try {
    checkVariableIsDefinedOrThrow(startDate, "startDate");
    checkVariableIsDefinedOrThrow(endDate, "endDate");
    
    let startDate_YYYYMMDD = moment(startDate).format('YYYY-MM-DD');
    let endDate_YYYYMMDD = moment(endDate).format('YYYY-MM-DD'); 

    let requestBody = {
      startDate: startDate_YYYYMMDD,
      endDate: endDate_YYYYMMDD,
      statusFilterArray: statusFilterArray
    }

    let url = `${process.env.REACT_APP_API_URL}/api/front-end/get-user-front-end-data-co2-energy-average-distance`;

    let userFrontEndData = await postJsonRequest(url, requestBody);

    return userFrontEndData;
  } catch (error) {
    console.error(`Cannot obtain user front-end data : ${error}`)
  }
};

export const getUserFrontEndData_CO2_Energy_AverageDistanceByCountry = async (startDate, endDate, statusFilterArray, countryId) => {
  try {
    checkVariableIsDefinedOrThrow(startDate, "startDate");
    checkVariableIsDefinedOrThrow(endDate, "endDate");
    
    let startDate_YYYYMMDD = moment(startDate).format('YYYY-MM-DD');
    let endDate_YYYYMMDD = moment(endDate).format('YYYY-MM-DD'); 

    let requestBody = {
      startDate: startDate_YYYYMMDD,
      endDate: endDate_YYYYMMDD,
      statusFilterArray: statusFilterArray
    }

    let url = `${process.env.REACT_APP_API_URL}/api/front-end/get-user-front-end-data-co2-energy-average-distance/country/${countryId}`;

    let userFrontEndData = await postJsonRequest(url, requestBody);

    return userFrontEndData;
  } catch (error) {
    console.error(`Cannot obtain user front-end data : ${error}`)
  }
};

export const getProducingAssetPercentageForUserAndRange = async(startDate, endDate, statusFilterArray) => {
  const GET_PRODUCING_ASSET_PERCENTAGE_URL = makeCompleteUrlFromLastPart("/api/graph-data/percentage-matched-for-user");
  let body = {
    startDate: startDate,
    endDate: endDate,
    statusFilterArray: statusFilterArray
  }

  let producingAssetPercentageForUserAndRange = await postJsonRequest(GET_PRODUCING_ASSET_PERCENTAGE_URL, body);

  return producingAssetPercentageForUserAndRange;
}
export const getProducingAssetPercentageForUserForRangeAndCountry = async(startDate, endDate, statusFilterArray, countryId) => {
  const GET_PRODUCING_ASSET_PERCENTAGE_URL = makeCompleteUrlFromLastPart("/api/graph-data/percentage-matched-for-user/country/" + countryId);
  let body = {
    startDate: startDate,
    endDate: endDate,
    statusFilterArray: statusFilterArray
  }

  let producingAssetPercentageForUserAndRange = await postJsonRequest(GET_PRODUCING_ASSET_PERCENTAGE_URL, body);

  return producingAssetPercentageForUserAndRange;
}

export const getLastMatchedStartDateForUser = async (statusFilterArray) => {
  const GET_LAST_MATCHED_DATE_FOR_USER_URL = makeCompleteUrlFromLastPart("/api/graph-data/last-matched-date-for-user");
  let body = {
    statusFilterArray: statusFilterArray
  }

  let lastMatchedStartDateForUser = await postJsonRequest(GET_LAST_MATCHED_DATE_FOR_USER_URL, body);

  return lastMatchedStartDateForUser;
}

export const getLastMatchedDateForUserPerCountry = async (statusFilterArray, countryId) => {
  const GET_LAST_MATCHED_DATE_FOR_USER_URL = makeCompleteUrlFromLastPart("/api/graph-data/last-matched-date-for-user/country/" + countryId);
  let body = {
    statusFilterArray: statusFilterArray
  }

  let lastMatchedStartDateForUser = await postJsonRequest(GET_LAST_MATCHED_DATE_FOR_USER_URL, body);

  return lastMatchedStartDateForUser;
}

export const getProducingAssetPercentageForUserAndLastMatchedDay = async(statusFilterArray) => {
  const GET_PRODUCING_ASSET_PERCENTAGE_URL = makeCompleteUrlFromLastPart("/api/graph-data/percentage-matched-for-user-for-last-matched-day");
  
  let body = {
    statusFilterArray: statusFilterArray
  }
  let producingAssetPercentageForUserAndLastMatchedDay = await postJsonRequest(GET_PRODUCING_ASSET_PERCENTAGE_URL, body);
  
  return producingAssetPercentageForUserAndLastMatchedDay;
}

export const getProducingAssetPercentageForUserForLastMatchedDayAndCountry = async(statusFilterArray, countryId) => {
  const GET_PRODUCING_ASSET_PERCENTAGE_URL = makeCompleteUrlFromLastPart("/api/graph-data/percentage-matched-for-user-for-last-matched-day/country/" + countryId);
  
  let body = {
    statusFilterArray: statusFilterArray
  }
  let producingAssetPercentageForUserAndLastMatchedDay = await postJsonRequest(GET_PRODUCING_ASSET_PERCENTAGE_URL, body);
  
  return producingAssetPercentageForUserAndLastMatchedDay;
}

export const dashboardStartNew = (countryId) => async dispatch => {
  try {
    let statusFilterArray = DEFAULT_CERTIFICATE_STATUS_FILTER_ARRAY;
    let frequency = await getUserMatchingFrequency() 

    // Get last matched day
    let lastMatchedCertificateStartDate = countryId ?  await getLastMatchedDateForUserPerCountry(statusFilterArray, countryId) : await getLastMatchedStartDateForUser(statusFilterArray);

    let startOfPeriod;
    let endOfPeriod;

    if(frequency === enums.FrequencyTypes.HOURLY) {
      let lastMatchedDate = lastMatchedCertificateStartDate.lastMatchedDate;
      let timezone = lastMatchedCertificateStartDate.timezone;
      startOfPeriod = moment.tz(lastMatchedDate, timezone).subtract(29, "days").format("YYYY-MM-DD");
      endOfPeriod = moment.tz(lastMatchedDate, timezone).format("YYYY-MM-DD");
    } else if( frequency === enums.FrequencyTypes.MONTHLY) {
      //Last month and last 12 months on a monthly frequency
      startOfPeriod = get29DaysAgoFromDate_YYYYMMDD(lastMatchedCertificateStartDate);
      endOfPeriod = dateToYYYYMMDD(lastMatchedCertificateStartDate);
    } else {
      startOfPeriod = get29DaysAgoFromDate_YYYYMMDD(lastMatchedCertificateStartDate);
      endOfPeriod = dateToYYYYMMDD(lastMatchedCertificateStartDate);
    }

    let doughnutStartDate = startOfPeriod;
    let doughnutEndDate = endOfPeriod;

    let cardsStartDate = startOfPeriod
    let cardsEndDate = endOfPeriod

    let currentUser = getCurrentUser();

 
    
    let userIsSuperAdmin = userHasRole(currentUser, UserRole.SUPER_ADMIN);

    // Get all data to print in parallel
    let parallelReturnedObject = await Promise.all(
      [
        countryId ? getConsumingAssetsByCountry(countryId): getConsumingAssets(),
        countryId ? getProducingAssetPercentageForUserForRangeAndCountry(doughnutStartDate, doughnutEndDate, statusFilterArray, countryId) : getProducingAssetPercentageForUserAndRange(doughnutStartDate, doughnutEndDate, statusFilterArray),
        userIsSuperAdmin ? null : (countryId ? getProducingAssetPercentageForUserForLastMatchedDayAndCountry(statusFilterArray, countryId): getProducingAssetPercentageForUserAndLastMatchedDay(statusFilterArray)),
        countryId ? getUserFrontEndData_CO2_Energy_AverageDistanceByCountry(cardsStartDate, cardsEndDate, statusFilterArray, countryId) : getUserFrontEndData_CO2_Energy_AverageDistance(cardsStartDate, cardsEndDate, statusFilterArray) 
      ]
    );

    // Destructure returned object
    let [
      consumingAssets,
      producingAssetPercentageForRange,
      producingAssetPercentageForLastMatchedDay,
      userFrontEndData
    ] = parallelReturnedObject;

    // Dispatch values
     dispatch({
      type: ACTION_TYPE.DASHBOARD.SET_MATCHING_FREQUENCY,
      payload: frequency
    });

    dispatch({
      type: ACTION_TYPE.DASHBOARD.GET_ASSETS_CONSUMING_SUCCESS,
      payload: consumingAssets
    });
    
    let activeUserConsumingAssets = consumingAssets.filter(c => c.active === true);
    
    dispatch({
      type: ACTION_TYPE.DASHBOARD.SET_ACTIVE_USER_CONSUMING_ASSETS,
      payload: activeUserConsumingAssets
    });

    dispatch({
      type: ACTION_TYPE.DASHBOARD.GET_PRODUCING_ASSET_PERCENTAGE_FOR_RANGE_SUCCESS,
      payload: producingAssetPercentageForRange
    });

    if(!userIsSuperAdmin) {
      dispatch({
        type: ACTION_TYPE.DASHBOARD.GET_PRODUCING_ASSET_PERCENTAGE_LAST_MATCHED_DAY_SUCCESS,
        payload: producingAssetPercentageForLastMatchedDay
      });
    }

    dispatch({
      type: ACTION_TYPE.DASHBOARD.GET_FRONT_END_DATA_FOR_USER,
      payload: userFrontEndData
    });

    dispatch({
      type: ACTION_TYPE.DASHBOARD.SET_LAST_DASHBOARD_LOAD
    });
  } catch (error) {
    console.error(error)
    dispatch({ type: ACTION_TYPE.MESSAGE_DIALOG.OPEN_ERROR });
  }

};

export const globalViewButtonClicked = () => dispatch => {
  dispatch({ type: ACTION_TYPE.DASHBOARD.GLOBAL_VIEW_BUTTON_CLICKED });
};

export const countryViewButtonClicked = () => dispatch => {
  dispatch({ type: ACTION_TYPE.DASHBOARD.COUNTRY_VIEW_BUTTON_CLICKED });
};

export const startLoadingDashboard = () => dispatch => {
  dispatch({ type: ACTION_TYPE.DASHBOARD.START_LOADING });
};
export const setCountriesMenuState = (open) => dispatch => {
  dispatch({ type: "COUNTRIES_MENU_STATE_CHANGED", payload: open});
};

export const stopLoadingDashboard = () => dispatch => {
  dispatch({ type: ACTION_TYPE.DASHBOARD.STOP_LOADING });
};

export const toggleCo2DetailsDialog_Dashboard = () => dispatch => {
  dispatch({ type: ACTION_TYPE.DASHBOARD.TOGGLE_CO2_DETAILS });
};



// WEBPACK FOOTER //
// ./src/actions/DashboardActions.js